import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonTranslationModule, CommonLayoutModule } from '@sdbn/common';
import { MaterialModule, ServiceResponseModule } from '@sdbn/appclient';
import { DictionaryModule } from '@sdbn/appclient';
import { RegistrationWithCodeQRCodeCombinedComponent } from './component/registration-with-code-qrcode-combined.component';
import { ZXingScannerModule } from '@zxing/ngx-scanner';

@NgModule({
  declarations: [
    RegistrationWithCodeQRCodeCombinedComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    DictionaryModule,
    FormsModule,
    ReactiveFormsModule,
    CommonTranslationModule,
    ServiceResponseModule,
    CommonLayoutModule,
    ZXingScannerModule
  ]
})
export class RegistrationWithCodeQRCodeCombinedModule { }
